export default {
    hostname: "https://music.sanplex.tech",
}